export enum RouteTitle {
  PUBLICATIONS = 'routes:publications',
  INVITATION_SETTINGS = 'invitationSettings:title',
  PASSWORD = 'password:changePassword:title',
  // CONTACT_FORM = 'tenantContactForm:contactForm.title',
  EMPLOYEES = 'tenantEmployees:employees.title',
  ORGANIZATION_DETAILS = 'organizationDetails:title',
  MOBILE_APP_MANAGEMENT = 'routes:mobileAppManagement',
  TENANTS = 'routes:tenants',
  SITE_MANAGEMENT = 'routes:siteManagement',
  SITE_DETAILS = 'routes:siteDetails',
  // PLACES = 'sitePlaces:places.title',
  ENVIRONMENTAL_INDICATORS = 'siteEnvironmentalIndicators:indicators.title',
  POLLS = 'tenantPolls:polls.title',
  POSTS = 'tenantPosts:posts.tab',
  // EVENTS = 'tenantEvents:events.tab',
  MESSAGES = 'messages:tab.title',
  FAQS = 'siteFaqs:tab.title',
  // SURVEYS = 'tenantPolls:polls.title',
  ARTICLES = 'tenantPosts:posts.tab',
  AUDIT_LOGS = 'auditLogs:common.route',
  // ISSUES = 'siteIssues:common.title',
  //hilight
  PROPERTY_MEMBERS = 'sitePropertyMembers:common.sidebarTitle',
  AMENITIES = 'spaces:common.sidebarTitle',
  MOBILE_APP_DISPLAY = 'mobileAppDisplay:common.sidebarTitle',
  PUSH_NOTIFICATIONS = 'sitePushNotifications:common.sidebarTitle',
  NEWS = 'siteNews:common.sidebarTitle',
  EVENTS = 'siteEvents:common.sidebarTitle',
  PLACES = 'sitePlaces:common.sidebarTitle',
  SURVEYS = 'sitePolls:common.sidebarTitle',
  PARTNERSHIPS = 'sitePartnerships:common.sidebarTitle',
  GUESTS = 'siteGuests:common.sidebarTitle',
  BOOKINGS = 'siteBookings:common.sidebarTitle',
  ISSUES = 'siteIssues:common.sidebarTitle',
  ADMINS_AND_CONCIERGES = 'siteManagement:common.sidebarTitle',
  CONTACT_FORM = 'siteContactForm:common.sidebarTitle',
}

export enum SidebarRouteTitle {
  SETUP = 'routes:setup',
  PROFILE = 'routes:profile',
  SUPPORT_AND_SETTINGS = 'routes:supportAndSettings',
  PUBLICATIONS = 'routes:publications',
  //hilight
  BUILDING_MANAGEMENT = 'routes:buildingManagement',
  APP_CONTENT = 'routes:appContent',
  DATA_AND_ISSUES = 'routes:dataAndIssues',
}

export enum SubRouteTitle {}
